import React from "react";
import styled from "styled-components";
import Benefit from "./Benefit";
import { breakpoints } from "../../utils/breakpoints";

// images/assets
import topUpIcon from "../../images/topup2025.png";
import generationalIcon from "../../images/match2025.png";
import binaryTeam from "../../images/binary2025.png";
import fastStart from "../../images/fast2025.png";
import leaderboard from "../../images/leader2025.png";
import millionDollar from "../../images/xplo2025.png";
import rapidFire from "../../images/rapid2025.png";
import x6x12 from "../../images/pie2025.png";

const StyledDiv = styled.div`
	padding-bottom: 100px;

	.benefits-container {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-gap: 20px;
		height: 100%;



	}

	
		.heading{
			background: linear-gradient(180deg, #89D0C2 0%, #44B2DD 100%);
			font-family: "nexa-bold";
			background-clip: text;
			font-weight: 900;
			-webkit-background-clip: text;
			padding-bottom: 10px;
			-webkit-text-fill-color: transparent;
			
		}

	@media screen and ${breakpoints.device.mobileL} {

		.heading{
		padding-top: 15px;
		}
		.benefits-container {
			grid-template-columns: 1fr 1fr;
			row-gap: 30px;
			width: 90%;
			margin: auto;
		}

		padding-bottom: 20px;
	}
`;

const BenefitsSection = () => {
	return (
		<StyledDiv className="benefits-section">
			<div data-aos="fade-down">
				<div className="heading">Benefits</div>
				<p>
					iGenius members are rewarded for
					attracting and retaining new members.
				</p>
				<br />
			</div>
			<div className="benefits-container">
				{benefits.map(({ icon, txt }, idx) => (
					<Benefit
						key={idx}
						icon={icon}
						txt={txt}
					/>
				))}
			</div>
		</StyledDiv>
	);
};

const benefits = [
	{
		icon: <img src={fastStart} alt="" />,
		txt: (
			<>
				Fast Start
				<br />
				Bonuses
			</>
		),
	},
	{
		icon: <img src={rapidFire} alt="" />,
		txt: (
			<>
				Rapid Fire
				<br />
				Bonuses
			</>
		),
	},
	{
		icon: <img src={topUpIcon} alt="" />,
		txt: (
			<>
				Top Up
				<br />
				Bonuses
			</>
		),
	},
	{
		icon: <img src={x6x12} alt="" />,
		txt: (
			<>
				X6 & X12
				<br />
				Bonuses
			</>
		),
	},
	{
		icon: <img src={leaderboard} alt="" />,
		txt: (
			<>
				Leaderboard
				<br />
				Bonuses
			</>
		),
	},
	{
		icon: <img src={binaryTeam} alt="" />,
		txt: (
			<>
				Binary Team
				<br />
				Commissions
			</>
		),
	},
	{
		icon: <img src={millionDollar} alt="" />,
		txt: (
			<>
				XPLOREpro
				<br />
				Bonus
			</>
		),
	},
	
	{
		icon: <img src={generationalIcon} alt="" />,
		txt: (
			<>
				Generational
				<br />
				Match
			</>
		),
	},
];

export default BenefitsSection;
